import { OpenAPIV3_1 } from 'openapi-types';

export const extractContentType = (
  input?: OpenAPIV3_1.ResponseObject | OpenAPIV3_1.RequestBodyObject
) => {
  if (!input?.content) return null;

  const contentType = Object.keys(input.content)[0];
  const schema = input.content[contentType]?.schema;
  const isRequired = (input as any)?.required ?? false;

  return { contentType, schema, isRequired };
};

export const getSchemaProperties = (
  schema: OpenAPIV3_1.SchemaObject | undefined
): Record<string, OpenAPIV3_1.SchemaObject> | undefined => {
  if (!schema) return undefined;

  const isArray = schema.type === 'array';
  const actualSchema = isArray ? schema.items : schema;

  return (actualSchema as OpenAPIV3_1.SchemaObject)?.properties;
};

export const getFieldIsRequired = (
  schema: OpenAPIV3_1.SchemaObject | undefined,
  key: string
): boolean => {
  return !!(schema as any)?.required?.includes?.(key);
};
